import type { BaseQueryApi, fetchBaseQuery } from '@reduxjs/toolkit/query';

type BaseQuery = ReturnType<typeof fetchBaseQuery>;
type RefreshResult = Awaited<ReturnType<BaseQuery>>;

// Refresh en vuelo compartido por todas las APIs: sin esto, cada query que recibe 401 en
// paralelo dispara su propio POST /auth/refresh-token contra Cognito.
let refreshEnCurso: Promise<RefreshResult> | null = null;

export const refrescarSesion = (
    baseQuery: BaseQuery,
    api: BaseQueryApi,
    extraOptions: object
): Promise<RefreshResult> => {
    if (!refreshEnCurso) {
        const { auth }: any = api.getState();
        refreshEnCurso = Promise.resolve(
            baseQuery(
                {
                    url: '/auth/refresh-token',
                    method: 'POST',
                    credentials: 'include',
                    body: { username: auth?.user?.usuario }
                },
                api,
                extraOptions
            )
        ).finally(() => {
            refreshEnCurso = null;
        });
    }
    return refreshEnCurso;
};
